import axios from "axios";
const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';
const api = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 10000,
});

const token = localStorage.getItem("token");
if (token) {
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const url = error.config?.url || "";
      if (!url.includes("/login")) {
        localStorage.removeItem("token");
        localStorage.removeItem("member_token");
        localStorage.removeItem("member_data");
        localStorage.removeItem("currentBranch");
      }
    }
    return Promise.reject(error);
  }
);

export default api;